<div class="content-block">
    <div class="row">
        <div class="col">
            <img class="img-fluid" alt="" *ngIf="content.imageUrl" [src]="content.imageUrl" />
        </div>
    </div>
    <span *ngIf="content.icon" class="fa fa-3x icon" [ngClass]="content.icon"></span>
    <h4 *ngIf="content.header" class="header" [innerHTML]="header"></h4>
    <div style="width:100%" [innerHTML]="contentBlock"></div>
</div>